import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUser } from '@isoft-people/types';

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  refreshToken: string | null;
  setSession: (user: AuthUser, token: string, refreshToken: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      refreshToken: null,
      setSession: (user, token, refreshToken) => set({ user, token, refreshToken }),
      logout: () => set({ user: null, token: null, refreshToken: null }),
    }),
    { name: 'isoft-people-auth' },
  ),
);
